var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSanitisationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 134,
    viewBox: "0 0 118 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.449 55.2487L117.859 48.1833H72.3128L89.4602 19.2467C101.273 22.3687 110.352 32.2731 112.303 44.5411H117.488C115.568 30.3535 105.505 18.7782 92.1695 14.6783L100.87 0H89.5426L81.7699 13.0737C81.6898 13.0737 81.6097 13.0627 81.5307 13.0627C63.1387 13.0627 47.9768 26.772 45.5749 44.5414H50.7588C52.9788 30.5758 64.4287 19.6518 78.6408 18.3354L60.8907 48.1813H45.2027L46.6128 55.2467H56.6854L53.6292 60.3865H47.6365L48.7492 65.954H50.3195L27.2681 104.715H8.55363C4.32316 104.715 0.861021 107.848 0.861021 111.675V119.198H68.1766V112.425H105.04L113.287 71.0936L58.7316 71.0947L61.7791 65.9548H114.312L115.423 60.3874H65.078L68.1255 55.2475L116.449 55.2487ZM56.4855 104.713H38.8046L52.0323 82.3977L56.4855 104.713Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.859375 120.883H6.095V134H0.859375V120.883Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9386 120.883H68.1742V134H62.9386V120.883Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0697 120.883H59.3053V134H54.0697V120.883Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2032 120.883H50.4389V134H45.2032V120.883Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3343 120.883H41.5699V134H36.3343V120.883Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4654 120.883H32.701V134H27.4654V120.883Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5964 120.883H23.832V134H18.5964V120.883Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72831 120.883H14.9639V134H9.72831V120.883Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanitisationIcon);
export default __webpack_public_path__ + "static/media/sanitisationIcon.8de9e4a7dcc2a9698f4216fe175f095a.svg";
export { ForwardRef as ReactComponent };